<template>
  <div>
    <v-list subheader>
      <v-subheader>Profile</v-subheader>
      <v-list-tile avatar @click="options = !options" ripple class="profile-item">
        <v-list-tile-avatar color="primary">
          <span class="white--text headline">{{user.name.charAt(0).toUpperCase()}}</span>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{user.name}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>

    <v-list subheader>
      <v-subheader>Operations</v-subheader>
      <nav-list-tile :item="dashboard"></nav-list-tile>
      <!-- <nav-list-tile :item="$store.state.global.pages.user">
      </nav-list-tile>-->
      <!-- Top Level Pages -->
      <nav-list-tile v-for="(item, i) in $store.state.global.topLevelPages" :key="i" :item="item"></nav-list-tile>

      <!-- Minor Pages -->
      <v-list-group>
        <v-list-tile slot="activator">
          <v-list-tile-action>
            <v-icon color="black">more_horiz</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>More...</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div v-for="(item, i) in $store.state.global.minorPages" :key="i">
          <nav-list-tile :key="i" :item="item"></nav-list-tile>
          <v-divider v-if="item.endOfCategory && item.link != 'driver'"></v-divider>
        </div>
      </v-list-group>

      <v-divider></v-divider>
    </v-list>

    <v-list subheader>
      <v-subheader>System</v-subheader>
      <!-- <v-list-tile color="" ripple @click="moreSettings = true">
                <v-list-tile-action>
                    <v-icon color="black">settings</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        Settings
                    </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon>
                        keyboard_arrow_right
                    </v-icon>
                </v-list-tile-action>
      </v-list-tile>-->
      <!-- End Settings group -->

      <v-list-tile
        v-if="$store.state.user.userAuthClass.name=='Administrator'"
        value="true"
        @click="backupDialog=true"
        ripple
      >
        <v-list-tile-action>
          <v-icon color="grey">cloud_download</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="grey--text">Backup DB</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile value="true" @click="logout()" ripple>
        <v-list-tile-action>
          <v-icon>power_settings_new</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <!-- More Settings dialog -->
    <v-dialog v-model="moreSettings" fullscreen hide-overlay transition="scale-transition">
      <more-settings @close="moreSettings = false"></more-settings>
    </v-dialog>

    <!-- Backup dialog -->
    <v-dialog v-model="backupDialog" max-width="700px" hide-overlay transition="scale-transition">
      <backup @close="backupDialog = false"></backup>
    </v-dialog>
  </div>
</template>

<script>
import NavListTile from "@/components/navigation/navListTile";
import MoreSettings from "@/components/misc/moreSettings";
import Backup from "@/components/misc/backup";
export default {
  components: {
    NavListTile,
    MoreSettings,
    Backup
  },
  data() {
    return {
      options: false,
      backupDialog: false,
      moreSettings: false,
      dashboard: {
        icon: "dashboard",
        title: "Dashboard",
        color: "grey",
        link: "dashboard"
      }
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("user/setLogout");
      this.$router.replace({
        name: "login"
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    }
  }
};
</script>

<style>
</style>
